export const POSTHOG_API_KEY =
  process.env.VUE_APP_POSTHOG_API_KEY !== undefined;
